import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import Scripts from '@/utils';
import Vuetify from 'vuetify'
import Keycloak from "keycloak-js";
import consts from "@/helpers/consts";
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import '@/assets/styles/main.sass'
import Tooltip from "@/utils/Tooltip";
import {VueMaskDirective} from "v-mask";


Vue.use(Vuetify);

const tooltip = new Tooltip();

tooltip.initialize();
Vue.directive("mask", VueMaskDirective);
Vue.prototype.$scripts = Scripts;
Vue.prototype.$consts = consts;
Vue.config.productionTip = false

// const initOptions = {
//     url: 'https://auth.ined.ru/auth',
//     realm: 'Ined_users',
//     clientId: 'ined_client',
//     onLoad: 'login-required'
// };

let initOptions;

if (process.env.NODE_ENV === 'development') {
    initOptions = {
        url: 'https://auth.test.ined.ru/',
        realm: 'test_sso',
        clientId: 'test_client',
        onLoad: 'login-required',
        messageReceiveTimeout: 2000,
    };
} else {
    initOptions = {
        url: 'https://auth.ined.ru/auth',
        realm: 'Ined_users',
        clientId: 'ined_client',
        onLoad: 'login-required',
        messageReceiveTimeout: 2000,
    };
}
const keycloak = new Keycloak(initOptions);
const authenticated = keycloak.init({onLoad: initOptions.onLoad}).then((auth) => {
    if (!auth) {
        console.log('UnAuthorized', auth)
    } else {
        console.log("Authenticated", auth);
//        store.dispatch('Default/setAuthData', keycloak);
        new Vue({
            router,
            store,
            vuetify: new Vuetify(
                {
                    icons: {
                        iconfont: 'mdi',
                        // values: {
                        //     customIconSvg: addFile,
                        //     customIconSvgPath: 'M1 20.5V2.5C1 2.23478 1.10536 1.98043 1.29289 1.79289C1.48043 1.60536 1.73478 1.5 2 1.5H8.66667C8.88304 1.5 9.09357 1.57018 9.26667 1.7L12.7333 4.3C12.9064 4.42982 13.117 4.5 13.3333 4.5H22C22.2652 4.5 22.5196 4.60536 22.7071 4.79289C22.8946 4.98043 23 5.23478 23 5.5V8.5M1 20.5L4.77208 9.18377C4.83845 8.98466 4.96578 8.81148 5.13605 8.68876C5.30631 8.56604 5.51088 8.5 5.72076 8.5H25.6126C25.771 8.5 25.9272 8.53765 26.0683 8.60986C26.2093 8.68206 26.3312 8.78675 26.4238 8.91529C26.5165 9.04383 26.5772 9.19255 26.6011 9.34919C26.625 9.50583 26.6114 9.66591 26.5613 9.81623L23 20.5H1Z'
                        // }
                    },
                    theme: {
                        themes: {
                            light: {
                                primary: '#00599B',
                                secondary: '#78909C',
                                accent: '#0288D1',
                                error: '#ED393E',
                                info: '#78909C',
                                success: '#29A128',
                                warning: '#D4990A',
                                orange: '#EB722E'
                            }
                        }
                    }
                }
            ),
            render: h => h(App, {props: {keycloak: keycloak, authenticated: authenticated}}),
        }).$mount('#app');
        //Token Refresh
        setInterval(() => {
            keycloak.updateToken(70).then((refreshed) => {
                if (refreshed) {
                    // console.log('Token refreshed' + refreshed);
                } else {
                    // console.log('Token not refreshed, valid for '
                    //     + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
                }
            }).catch(() => {
                console.log('Failed to refresh token');
            });
        }, 120000)
    }
}).catch(() => {
    console.log("Authenticated Failed");
    history.back()
});
